/**
 * 审核状态选项数据管理 Hook
 */
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getReviewStatusEnum } from '@/service/driverArchive';
import { setReviewStatusEnum } from '@/store/enum/actions';

export const useReviewStatusOptions = () => {
  const dispatch = useDispatch();
  const { reviewStatusEnum } = useSelector((state: any) => state.enumStore);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    // 如果 Redux 中已有数据，则不再请求
    if (reviewStatusEnum.length === 0) {
      fetchReviewStatusEnum();
    }
  }, []);

  const fetchReviewStatusEnum = async () => {
    try {
      setLoading(true);
      const res = await getReviewStatusEnum();
      const enumData = res.data?.data || [];
      const options = enumData.map((item: any) => ({
        label: item.first,
        value: item.second,
      }));
      // 将数据保存到 Redux
      dispatch(setReviewStatusEnum(options));
    } catch (error) {
      console.error('获取审核状态枚举失败:', error);
    } finally {
      setLoading(false);
    }
  };

  return { reviewStatusOptions: reviewStatusEnum, loading };
};
